<template>
  <PageTemplate class="day-use-view" title="Day Use" :loading="loading">
    <transition name="fade">
      <div v-if="!loading && items.length">
        <div class="mt-10 grid-list">
          <template v-for="(item, keyItems) in items">
            <DayUseCard :key="keyItems" v-bind="item" />
          </template>
        </div>

        <v-pagination
          v-if="pagesLength > 1"
          class="mt-10"
          color="secondary"
          v-model="page"
          :length="pagesLength"
        ></v-pagination>
      </div>
    </transition>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import DayUseCard from "../components/cards/DayUseCard.vue";
import { formatToURL } from "../utils/formatToURL";

const _config = {
  mod: "dayUse",
  path: "/day-use",
};

export default {
  data: () => ({
    loading: true,
    items: [],
    path: _config.path,
    itemsPerPage: 24,
    totalItems: 0,
  }),
  created() {
    this.get();
  },
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  methods: {
    get() {
      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
      };

      if (this.page) params.page = this.page;

      this.loading = true;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
        })
        .then(({ totalItems, list }) => {
          this.items = list.map(({ id, img, title, topics, price }) => ({
            img,
            title,
            topics: !topics ? [] : JSON.parse(topics),
            price: parseFloat(price),
            to: `${this.path}/${formatToURL(title)}-${id}`,
          }));
          this.totalItems = totalItems;

          if (!list.length && this.page > 1) this.page = 1;
        })
        .then(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.get();
    },
  },
  components: {
    PageTemplate,
    DayUseCard,
  },
};
</script>

<style lang="scss" scoped>
.day-use-view::v-deep {
  .title-widget {
    &:before,
    &:after {
      background-color: var(--v-success-base);
    }
  }
}

.grid-list {
  display: grid;
  gap: 30px 10px;
  grid-template-columns: repeat(3, 1fr);

  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
}
</style>
